import React, { useEffect, useState, useContext } from "react";
import { Col } from "reactstrap";
import * as toastr from "toastr"
import { useTranslation, composeInitialProps } from 'react-i18next'
import Styled from 'styled-components';

import BoxWhite from 'Placements/Components/BoxWhite';
import Button from 'Placements/Components/Button';
import LineBoxReport from 'Placements/Components/LineBoxReport';
import Loader from "Placements/Components/Loader"
import API from "Placements/API";
import getConfig from "Placements/Utils/GetRequestConfig.util"
import { ContainerFlex } from "Placements/Styles/Global.style";
import UserContext from "Placements/User.context"

const DivTitle = Styled.div`
    text-align: center;
    position: relative;
    color: ${(props) => props.theme.main.mainBlue};
    margin: 0 auto;
`;

const ButtonStyled = Styled(Button)`
    width: auto;    
    align-self: center;
    margin: 0 auto;
    margin-bottom: -40px;
`;

const TextInfo = Styled.p`
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    text-align: left !important;
`;

const TitleStyled = Styled.h3`
    display: block;
    position: relative;
    z-index: 1;
    font-size: 1.17em;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
`;

const NextTestDiv = Styled.div`
    width: 90%;
    margin: 0 auto 1rem;
    color: #505050;
`;

const PartialReport = (props: any) => {

    const [isLoading, setLoading] = useState(false);
    const [section, setSection] = useState<any>({});
    const [testPart, setTestPart] = useState<any>({});
    const [part, setPart] = useState<any>({});
    const [nextTest, setNextTest] = useState<any>({});
    const [info, setInfo] = useState<any>(null);
    const [scoreCategory, setScoreCategory] = useState([]);
    const { t, i18n } = useTranslation()
    const { usuario }: any = useContext(UserContext)

    useEffect(() => {

        setSection(JSON.parse(localStorage.getItem("SessaoPl")));

    }, []);

    useEffect(() => {

        if (section && Object.keys(section).length !== 0) {

            fetchTestPart();
            setPart(section.parte);

            if (info == null) {
                API.Test.Last({ idUsuario: usuario.Id_Usuario }, getConfig())
                    .then((response: any) => {
                        setInfo(response.data)
                    }).catch((error: any) => {
                        toastr.error('Não foi possível recuperar informações', error);
                    })
            }

        }

    }, [section]);

    useEffect(() => {

        if (Object.keys(testPart).length !== 0)
            fetchScoreCategories();

    }, [testPart]);

    useEffect(() => {

        if (Object.keys(part).length !== 0) {

            i18n.changeLanguage(part.Nome.indexOf("Test") != -1 ? "en" : "es");
            fetchPart();

        }

    }, [part]);

    const fetchTestPart = async () => {

        try {

            setLoading(true);

            const response = await API.TesteParte.Get({ idTestPart: section.idTesteParte }, getConfig());

            setTestPart(response.data);

            if (response.data.TesteCategorias.length == 0) {
                window.location.href = "#/test";
            }

        } catch (error) {

            toastr.error('Não foi possível obter os detalhes do teste', error);

        } finally {

            setLoading(false);

        }

    }

    const fetchPart = async () => {

        try {

            const version = part.Nome.indexOf("Test") != -1 ? "1" : "2";

            const responseNext = await API.TesteParte.GetPart({ versaoId: version, ordem: part.Ordem + 1 }, getConfig());
            setNextTest(responseNext.data);

        } catch (error) {
            toastr.error('Não foi possível obter o nome do teste', error);
        }

    }

    const fetchScoreCategories = async () => {

        try {

            const response = await API.TesteParte.GetScoreCategory({ idTesteParte: testPart.Id_Teste_Parte }, getConfig());
            setScoreCategory(response.data);

        } catch (error) {
            toastr.error('Não foi possível obter o resultado detalhado do teste');
        }

    };

    const goToNextTest = async () => {
        try {
            const { data } = await API.Sessao.Get({ idTesteUsuario: info.ultimoTesteUsuario }, getConfig())
            localStorage.setItem("SessaoPl", JSON.stringify(data))
            window.location.href = "#/test"
        } catch (error) {
            toastr.error(error);
        }
    }


    if (isLoading) { return <Loader /> }

    return (
        <ContainerFlex>
            <Col md={8} className="mb-4">
                <BoxWhite >
                    <DivTitle className='title'>
                        {t('partial-report-header')}
                    </DivTitle>
                    <div className="info">
                        <p className="text -center">
                            Veja seu aproveitamento no <strong>{part.Nome}</strong> abaixo:
                    </p>
                    </div>
                    <LineBoxReport>
                        {scoreCategory.map((score: any, index) => (
                            <div className="item" key={index}>
                                {score.Nome}
                                <span className="percent">
                                    {(score.Resultado * 100).toFixed(1)}%
                            </span>
                            </div>
                        ))}
                    </LineBoxReport>
                    <NextTestDiv>
                        {nextTest.Nome && <TitleStyled>
                            Pronto para o <em>{nextTest.Nome}</em>?
                    </TitleStyled>}
                        <TextInfo>
                            O teste a seguir é composto de {t('number-test-questions')} perguntas de múltipla escolha, envolvendo compreensão auditiva e escrita, vocabulário e gramática.
                            Se você tiver um ótimo desempenho pode ser direcionado ao próximo nível sem ter de completar todas as {t('number-test-questions')} questões.
                    </TextInfo>
                    </NextTestDiv>
                    {info && info.ultimoTesteUsuario && <div className="report-actions">
                        <ButtonStyled onClick={() => { goToNextTest() }}>
                            {nextTest.Nome}{t('partial-report-button')}
                        </ButtonStyled>
                    </div>
                    }
                </BoxWhite>
            </Col>
        </ContainerFlex>
    );
}

export default PartialReport;